var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessEnableMfa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 123,
    viewBox: "0 0 118 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "b",
    cx: 35.5,
    cy: 31,
    rx: 21.5,
    ry: 21
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "232.6%",
    height: "235.7%",
    x: "-66.3%",
    y: "-67.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.135762675 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    stroke: "#EAEAEA",
    strokeWidth: 2,
    d: "M42 11a2 2 0 0 0-2 2v96a2 2 0 0 0 2 2h51a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2H42zm0 3h51v89H42V14z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#06BB72",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M43 26L31.122 38 26 32.667"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.778,
    height: 23.087,
    x: 6.611,
    y: 1.5,
    stroke: "#979797",
    strokeWidth: 3,
    rx: 4.889
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 20.87,
    y: 9.13,
    fill: "#FFCD00",
    rx: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2E3D",
    fillRule: "nonzero",
    d: "M69.995 57.995V56l-1.249 1.189L67.473 56l-1.224 1.189L65 56v6.296a.7.7 0 0 0 .694.704h.015c.38 0 .69-.316.69-.704v-1.204h2.197v1.204a.7.7 0 0 0 .695.704h.015a.7.7 0 0 0 .694-.704v-3.327l-.005-.974zm-3.596 1.796v-.572a1.11 1.11 0 0 1 1.099-1.117c.604 0 1.098.5 1.098 1.117v.572H66.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessEnableMfa);
export default __webpack_public_path__ + "static/media/success-enable-mfa.7f7840758ccf233c3637d54bf927a027.svg";
export { ForwardRef as ReactComponent };